import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import packageJson from "../../../package.json";
import uRLs from "../../utils/baseUtils";

function SideMenu({ open, setOpen }) {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1280);
  const [expandedMenu, setExpandedMenu] = useState({});
  const handleLinkClick = () => {
    if (isMobile) {
      setOpen(false);
    }
  };

  const handleToggleMenu = (menuId) => {
    setExpandedMenu((prevMenu) => ({
      ...prevMenu,
      [menuId]: !prevMenu[menuId],
    }));
  };
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1280);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getWrapperClass = () => {
    if (window.innerWidth < 768) {
      return `wrapper ${open ? "toggled" : ""}`;
    } else {
      return "wrapper";
    }
  };

  const sidebarClass = open ? "sidebar-wrapper" : "sidebar-wrapper closed";
  const currentPath = location.pathname;  


  return (
    <>
      <div className={getWrapperClass()}>
        <div className="overlay toggle-icon" onClick={handleLinkClick}></div>
        <div className={sidebarClass} data-simplebar="true">
          <div className="sidebar-header">
            <div className="logo-container">
              {isMobile ? (
                <div className="d-flex">
                  <img
                    src={uRLs.LOGO_IMAGE}
                    className="logo-image"
                    alt="logo icon"
                  />
                  <div
                    className="toggle-icon ms-auto"
                    onClick={() => setOpen(!open)}
                  >
                    <i className="bx bx-arrow-back text-black mt-2 "></i>
                  </div>
                </div>
              ) : (
                <div
                className="d-flex align-item-center justify-content-center"
                >
                  <img
                    src="/assets/images/logo.png"
                    style={{
                      width: "145px",                     
                    }}
                    alt="logo icon"
                  />
                </div>
              )}
            </div>
          </div>

          {open && (
            <ul className="metismenu" id="menu">
              <li>
                <Link
                  to="/dashboard"
                  onClick={handleLinkClick}
                  className={currentPath === "/dashboard" ? "active" : ""}
                >
                  <div className="parent-icon">
                    <i className="bx bx-home-alt"></i>
                  </div>
                  <div className="menu-title">Dashboard</div>
                </Link>
              </li>           
            
            
               {/* <li 
                className={`mm-collapsable ${
                  expandedMenu["home"] ? "mm-active" : ""
                }`}
              >
                <div onClick={() => handleToggleMenu("home")}>
                  <Link
                    to="#"
                    className={`has-arrow ${
                      expandedMenu["home"] ? "active" : ""
                    }`}
                    aria-expanded={expandedMenu["home"]}
                  >
                    <div className="parent-icon">
                      <i className="bx bxs-home"></i>
                    </div>
                    <div className="menu-title">Home</div>
                  </Link>
                </div>
                {expandedMenu["home"] && (
                  <ul className="mm-collapse mm-show">
                    <li>
                      <Link
                        to="/slider"
                        onClick={handleLinkClick}
                        className={currentPath === "/slider" ? "active" : ""}
                      >
                        <i className="bx bx-right-arrow-alt"></i>Slider
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/promo"
                        onClick={handleLinkClick}
                        className={currentPath === "/promo" ? "active" : ""}
                      >
                        <i className="bx bx-right-arrow-alt"></i>Promo
                      </Link>
                    </li>
                    <li></li>
                  </ul>
                )}
              </li>
             */}


              <li>
                <Link
                  to="/booking"
                  onClick={handleLinkClick}
                  className={currentPath === "/booking" ? "active" : ""}
                >
                  <div className="parent-icon">
                    <i className="bx bx-shopping-bag"></i>
                  </div>
                  <div className="menu-title">Bookings & Enquiries</div>
                </Link>
              </li>
               <li>
                <Link
                  to="/interest"
                  onClick={handleLinkClick}
                  className={currentPath === "/interest" ? "active" : ""}
                >
                  <div className="parent-icon">
                    <i className="bx bx-line-chart"></i>
                  </div>
                  <div className="menu-title">Old Enquiries</div>
                </Link>
              </li>
               <li>
                <Link
                  to="/partner"
                  onClick={handleLinkClick}
                  className={currentPath === "/partner" ? "active" : ""}
                >
                  <div className="parent-icon">
                   <i className="bx bx-group"></i>
                  </div>
                  <div className="menu-title">Partnet list</div>
                </Link>
              </li>
              <li>
                <Link
                  to="/kyc"
                  onClick={handleLinkClick}
                  className={currentPath === "/kyc" ? "active" : ""}
                >
                  <div className="parent-icon">
                    <i className="bx bx-id-card"></i>
                  </div>
                  <div className="menu-title">KYC Management</div>
                </Link>
              </li>

            <li>
                <Link
                  to="/gangleader-management"
                  onClick={handleLinkClick}
                  className={currentPath === "/gangleader-management" ? "active" : ""}
                >
                  <div className="parent-icon">
                    <i className="bx bx-crown"></i>
                  </div>
                  <div className="menu-title"> Captains </div>
                </Link>
              </li>

               <li>
                <Link
                  to="/field-officer-management"
                  onClick={handleLinkClick}
                  className={currentPath === "/field-officer-management" ? "active" : ""}
                >
                  <div className="parent-icon">
                    <i className="bx bx-id-card"></i>
                  </div>
                  <div className="menu-title"> Field Officer Management </div>
                </Link>
              </li>
            </ul>
          )}
          
         <footer className="menu-footer text-start ms-6 booy-tstab position-fixed text-white  ">
            <span className="pe-3"> Version: {packageJson.version}</span>
          </footer>
        </div>
      </div>
    </>
  );
}

export default SideMenu;